// eslint-disable-next-line import/prefer-default-export
export function getErrorMessage(v) {
  if (!v) return null;
  const { $params: params } = v;

  if (v.required === false) {
    return 'This must be provided';
  }
  if (v.url === false) {
    return 'This must be a valid url';
  }
  if (v.numeric === false || v.decimal === false) {
    return 'This must be a number';
  }
  if (v.email === false) {
    return 'This must be an email address';
  }
  if (v.minLength === false) {
    return `This must have a minimum length of ${params.minLength.min}`;
  }
  return 'Input is invalid';
}
